import { ReactNode } from "react";
import { motion } from "framer-motion";

interface PageTransitionProps {
  children: ReactNode;
}

const pageVariants = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
};

import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { Suspense } from "react";

export const PageTransition = ({ children }: PageTransitionProps) => {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageVariants}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }} // Custom "luxury" cubic-bezier
      className="w-full min-h-screen"
    >
      <Suspense fallback={
        <div className="w-full h-[60vh] flex items-center justify-center">
          <LoadingSpinner />
        </div>
      }>
        {children}
      </Suspense>
    </motion.div>
  );
};
